import {ReactElement, useState} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {FutureTransaction} from "../../domain/transaction/FutureTransaction";
import {PageDto} from "../../domain/PageDto";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {TransactionSearchTerm} from "../../domain/transaction/TransactionSearchTerm";
import {useSearchFutureTransactions} from "../../application/FutureTransactionService";
import TransactionSearchBar, {TransactionSearchFields} from "./TransactionSearchBar";
import FutureTransactionComponent from "../../components/FutureTransactionComponent";
import IconButton from "@mui/material/IconButton";
import {Link, useParams} from "react-router-dom";
import {SyncProblemRounded} from "@mui/icons-material";
import {Collapse, Tooltip} from "@mui/material";

export default function FutureTransactionsPage(): ReactElement {
    const params = useParams();
    let initialSearchTerm: TransactionSearchTerm | null = null;
    if (params.assetManager && params.transactionId) {
        initialSearchTerm = {
            counterpart: '',
            fromDate: null,
            toDate: null,
            instrument: '',
            states: [],
            transaction: params.transactionId,
            assetManager: params.assetManager
        };
    }
    const searchFn: SearchDataFunction<TransactionSearchTerm, PageDto<FutureTransaction>> = useSearchFutureTransactions(initialSearchTerm);
    const [ searchExpanded, setSearchExpanded ] = useState<boolean>(false);

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <Grid size={{ xs: 12, md: 5, lg: 5 }}>
                    <Title>Future Transactions</Title>
                </Grid>
                <Grid size={{ xs: 12, md: 1, lg: 1 }}>
                    <Tooltip title={"View not confirmed transactions"} placement={"top"}>
                        <span>
                            <IconButton component={Link} to="/transaction/fu/active">
                                <SyncProblemRounded />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Grid>
                <TransactionSearchBar searchFn={ searchFn } expanded={searchExpanded} onToggle={setSearchExpanded}/>
            </Grid>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <TransactionSearchFields searchFn={ searchFn }/>
                    </Grid>
                </Grid>
            </Collapse>
            <Grid container spacing={2}>
                <FutureTransactionComponent searchFn={ searchFn}/>
            </Grid>
        </Container>
    );
}